import css from "styled-jsx/css";

export default css`
  .device-card {
    width: 100%;
    padding: 0 0.5rem;

    /* Contingencia textos largos (tam. no standard) para que no vayan a 2 lineas*/
    :global(.crazy-label) {
      @media (max-width: 405px) and (min-width: 336px) {
        font-size: 12px;
      }
    }
    
    &--container {
      width: 100%;
      margin-top: 0.75rem;
      &--image-stamp-container {
        height: 11.5rem;
        margin-bottom: 0.75rem;
        &--stamp {
          display: flex;
          justify-content: center;
          //margin-bottom: 0.5rem;
          margin-top: 0.1rem;
        }
        &--image-box {
          position: relative;
          height: 100%;
        }
        // Si hay sello la imagen del terminal la hago mas pequeña
        &--image-box.with-stamp {
          height: 9.5rem !important;
        }
      }

      &--post-saving {
        margin-bottom: 6px;
      }
      &--name {
        height: 3.75rem;

        :global(.text) {
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 110% !important;
          display: none;
        }
      }
      &--label {
        padding-bottom: 6px;
        height: auto;
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
      &--price-box {
        display: flex;
        justify-content: flex-start;
        &--relative {
          position: relative;
          margin-right: 0.5rem;
        }
      }
      &--bottom-text {
        width: 100%;
        min-height: 14px;
      }
      &--additionalPayment {
        min-height: 14px;
      }
      &--line-through {
        width: 75%;
        position: absolute;
        height: 20px;
        border-bottom: 1.5px solid rgb(153, 153, 153);
        bottom: 45%;
      }
      &--line-freeOffer {
        border-bottom: 1px solid #ddd;
        margin: 0.25rem 0;
      }
    }
  }

  :global(.device-card .card) {
    height: 100% !important;
  }

  :global(.device-card .layout-device) {
    padding: 0.5rem 1rem;
  }

  :global(.device-card .card) {
    height: 100% !important;
  }

  :global(.device-card--container--label:empty) {
    display: none !important;
  }

  :global(.device-card--container--price-box .price .price--unity > span) {
    margin-left: 0.15rem;
  }

  :global(.device-card--container--price-box .price .price--quote > span) {
  }

  :global(
      .device-card--container--price-box--promo .price .price--unity > span
    ) {
    margin-left: 0.15rem;
  }

  :global(
      .device-card--container--price-box--promo .price .price--quote > span
    ) {
  }

  /* Desktop */
  @media screen and (min-width: 768px) {
    .device-card {
      &--container {
        width: 100%;
      }
    }
  }
`;
